"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KeyboardDetectionProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _KeyboardDetectionContext = require("../../contexts/KeyboardDetectionContext.js");
var _useKeyboardDetection2 = require("../../hooks/useKeyboardDetection.js");
var isUsingKeyboardDefault = _KeyboardDetectionContext.keyboardDetectionContextDefault.isUsingKeyboard;
/**
 * KeyboardDetectionProvider is a wrapper that allows Encore components to alter their focus styles
 * depending on a user's navigation method (keyboard, mouse or touch).
 *
 * [Encore site](https://encore.spotify.net/web/patterns/displaying-focus-indicators) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/KeyboardDetectionProvider)
 */
var KeyboardDetectionProvider = exports.KeyboardDetectionProvider = function KeyboardDetectionProvider(props) {
  var _useKeyboardDetection = (0, _useKeyboardDetection2.useKeyboardDetection)(isUsingKeyboardDefault),
    isUsingKeyboard = _useKeyboardDetection.isUsingKeyboard;
  return /*#__PURE__*/_react["default"].createElement(_KeyboardDetectionContext.KeyboardDetectionContext.Provider, {
    value: {
      isUsingKeyboard: isUsingKeyboard
    }
  }, props.children);
};